module.exports = __webpack_public_path__ + "static/media/Cripta.fdfe1a94.svg";